module.exports = window.crypto;